module.exports = __webpack_public_path__ + "img/2024big22.ddc3ecda.png";